import {
    createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import App from '../App.js';
import Error404 from './Error404.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/project/bases',
        element: <App m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/project/details',
        element: <App m={12} />,
        errorElement: <Error404 />,
    }, {
        path: '/project/offers',
        element: <App m={13} />,
        errorElement: <Error404 />,
    }, {
        path: '/project/progressLogs',
        element: <App m={14} />,
        errorElement: <Error404 />,
    }, {
        path: '/project/repayments',
        element: <App m={15} />,
        errorElement: <Error404 />,
    }, {
        path: '/cars',
        element: <App m={21} />,
        errorElement: <Error404 />,
    }, {
        path: '/car/repairs',
        element: <App m={22} />,
        errorElement: <Error404 />,
    }, {
        path: '/car/oils',
        element: <App m={23} />,
        errorElement: <Error404 />,
    }, {
        path: '/car/mileages',
        element: <App m={24} />,
        errorElement: <Error404 />,
    }, {
        path: '/wos',
        element: <App m={31} />,
        errorElement: <Error404 />,
    }, {
        path: '/wo/visits',
        element: <App m={32} />,
        errorElement: <Error404 />,
    }, {
        path: '/wo/dousers',
        element: <App m={33} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wtcd',
        element: <App m={401} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wdct',
        element: <App m={402} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wdcl',
        element: <App m={403} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wdcr',
        element: <App m={404} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wdcp',
        element: <App m={405} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/diem',
        element: <App m={406} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/wo/wdcd',
        element: <App m={407} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/car/cdco',
        element: <App m={408} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/project/dcay',
        element: <App m={409} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/project/dray',
        element: <App m={410} />,
        errorElement: <Error404 />,
    }, {
        path: '/log/operations',
        element: <App m={51} />,
        errorElement: <Error404 />,
    },
]);

export default BasicRouter